import {
  Button,
  DatePicker,
  Form,
  Modal,
  Select,
  Space,
  Typography,
} from 'antd';
import axios, { type AxiosResponse } from 'axios';
import React, { useState } from 'react';

import { asyncErrorHandler } from '@/utils/asyncErrorHandler';

import sharedStyles from '../sharedStyles.module.scss';
import { initFormValues } from './constants';
import styles from './index.module.scss';
import type { CommunityAndCleanKindList, ExportExcelFormValues } from './types';

const { Item, useForm } = Form;
const { Text } = Typography;

const ExportExcel = () => {
  const [exportExcelForm] = useForm<ExportExcelFormValues>();

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [communityAndCleanKindList, setCommunityAndCleanKindList] =
    useState<CommunityAndCleanKindList>();

  const getCommunityAndCleanKindList = async () => {
    try {
      const res: AxiosResponse<CommunityAndCleanKindList> = await axios({
        method: 'GET',
        url: '/ezcon/api/getExportableCommunitiesAndCleanKinds?reservationType=一般',
        headers: {
          authorization: localStorage.getItem('feathers-jwt'),
        },
      });
      setCommunityAndCleanKindList(res.data);
      setIsOpenModal(true);
    } catch (error) {
      asyncErrorHandler(
        error.response.data,
        '匯出Excel功能發生錯誤，請稍後再試!'
      );
    }
  };

  const exportExcel = async (formValues: ExportExcelFormValues) => {
    const startTime = formValues.startTime.valueOf();
    const endTime = formValues.endTime.valueOf();
    let url = `/ezcon/api/cleanExcel?startTime=${startTime}&endTime=${endTime}&reservationType=一般`;
    if (formValues.communityName) {
      url = `${url}&communityName=${formValues.communityName}`;
    }
    if (formValues.cleanKindName) {
      url = `${url}&cleanKindName=${formValues.cleanKindName}`;
    }

    try {
      const res = await axios({
        method: 'GET',
        url,
        headers: {
          authorization: localStorage.getItem('feathers-jwt'),
        },
        responseType: 'blob',
      });
      const link = document.createElement('a');

      const blob = new Blob([res.data]);
      link.href = URL.createObjectURL(blob);
      link.download = '一般清潔預約清單.xlsx';
      link.click();
      setIsOpenModal(false);
    } catch (error) {
      asyncErrorHandler(error.response.data);
    }
  };

  const communityOptions =
    communityAndCleanKindList?.communities.map((community) => ({
      label: community,
      value: community,
    })) ?? [];
  const cleanKindOptions =
    communityAndCleanKindList?.cleanKindNames.map((cleanKind) => ({
      label: cleanKind,
      value: cleanKind,
    })) ?? [];

  return (
    <>
      <Button onClick={getCommunityAndCleanKindList}>匯出Excel</Button>
      <Modal
        open={isOpenModal}
        title="匯出Excel"
        centered
        destroyOnClose
        footer={null}
        onCancel={() => setIsOpenModal(false)}
      >
        <Form
          form={exportExcelForm}
          layout="vertical"
          preserve={false}
          initialValues={initFormValues}
          onFinish={exportExcel}
        >
          <Item label={<Text type="secondary">社區</Text>} name="communityName">
            <Select
              placeholder="請選擇社區"
              options={communityOptions}
              allowClear
            />
          </Item>
          <Item label={<Text type="secondary">類別</Text>} name="cleanKindName">
            <Select
              placeholder="請選擇類別"
              options={cleanKindOptions}
              allowClear
            />
          </Item>
          <Space className={styles.datePickerContainer} size="middle">
            <Item
              label={<Text type="secondary">起始時間</Text>}
              name="startTime"
              rules={[{ required: true, message: '請選擇起始時間' }]}
            >
              <DatePicker className={sharedStyles.widthFull} />
            </Item>
            <Item
              label={<Text type="secondary">截止時間</Text>}
              name="endTime"
              rules={[{ required: true, message: '請選擇截止時間' }]}
            >
              <DatePicker className={sharedStyles.widthFull} />
            </Item>
          </Space>
          <Space className={sharedStyles.footerButtonsContainer}>
            <Button onClick={() => setIsOpenModal(false)}>取消</Button>
            <Button type="primary" htmlType="submit">
              匯出
            </Button>
          </Space>
        </Form>
      </Modal>
    </>
  );
};

export default ExportExcel;
